<template>
    <az-container>
        <az-form>
            <v-dialog :value="!exibirModalConfirmarAlteracaoMeEpp" persistent max-width="1200" non-linear>
                <v-card>
                    <v-stepper v-model="passoAtual.sequencia">

                        <v-stepper-header color="primary" dark>
                            <v-stepper-step v-for="passo in passosFiltrados" :key="passo.sequencia"
                                            :complete="isPassoCompleto(passo)" :step="passo.sequencia">
                                {{passo.label}}
                                <v-divider></v-divider>
                            </v-stepper-step>
                            <v-btn icon color @click.native="$emit('fechar')" dark>
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content :step="passos.informacoesEmpresa.sequencia"
                                               v-if="isPassoSelecionado(passos.informacoesEmpresa)">
                                <licitacao-fornecedor-termos-info-empresa v-model="aceite"
                                                                          @proximo="proximoPasso"/>
                            </v-stepper-content>
                            <v-stepper-content :step="passos.termoCredenciamento.sequencia"
                                               v-if="isPassoSelecionado(passos.termoCredenciamento)">
                                <licitacao-fornecedor-termos-credenciamento :passoAtual="passoAtual.sequencia"
                                                                            :quantidadePassos="Object.keys(passosFiltrados).length"
                                                                            @proximo="proximoPasso"
                                                                            @voltar="voltarPasso"/>
                            </v-stepper-content>
                            <v-stepper-content :step="passos.termoHabilitacao.sequencia"
                                               v-if="isPassoSelecionado(passos.termoHabilitacao)">
                                <licitacao-fornecedor-termos-habilitacao :passoAtual="passoAtual.sequencia"
                                                                         :quantidadePassos="Object.keys(passosFiltrados).length"
                                                                         @proximo="proximoPasso"
                                                                         @voltar="voltarPasso"/>
                            </v-stepper-content>
                            <v-stepper-content :step="passos.termosPersonalizadosProposta.sequencia"
                                               v-if="isPassoSelecionado(passos.termosPersonalizadosProposta)">
                                <licitacao-fornecedor-termos-personalizados v-model="aceite" :termos="termosProposta"
                                                                            :passoAtual="passoAtual.sequencia"
                                                                            :quantidadePassos="Object.keys(passosFiltrados).length"
                                                                            @proximo="proximoPasso"
                                                                            @voltar="voltarPasso"/>
                            </v-stepper-content>
                            <v-stepper-content :step="passos.termosPersonalizadosHabilitacao.sequencia"
                                               v-if="isPassoSelecionado(passos.termosPersonalizadosHabilitacao)">
                                <licitacao-fornecedor-termos-personalizados v-model="aceite" :termos="termosHabilitacao"
                                                                            :passoAtual="passoAtual.sequencia"
                                                                            :quantidadePassos="Object.keys(passosFiltrados).length"
                                                                            @proximo="proximoPasso"
                                                                            @voltar="voltarPasso"/>
                            </v-stepper-content>
                        </v-stepper-items>

                    </v-stepper>

                </v-card>
            </v-dialog>
            <v-dialog :value="exibirModalConfirmarAlteracaoMeEpp" persistent max-width="500" non-linear>
              <v-card>
                <v-card-title class="primary modal-title py-2" primary-title>
                  Confirmar Alteração
                </v-card-title>
                <v-card-text v-if="ehPerfilSiga" style="color: #777">
                  <div style="text-align: center; width: 100%">Atenção!</div>
                  Você está alterando a declaração de Me/Epp/Mei para: <strong style="color: #3a3939">Não</strong>
                  <br>
                  Ao confirmar, as propostas enviadas para tipos exclusivos serão removidas.
                  <strong style="color: #3a3939">Esta ação não poderá ser desfeita.</strong>
                  Deseja continuar?
                </v-card-text>
                <v-card-text v-else style="color: #777">
                  <div style="text-align: center; width: 100%">Atenção!</div>
                  Você está alterando a declaração de Me/Epp/Mei para: <strong style="color: #3a3939">Não</strong>
                  <br>
                  Ao confirmar, as propostas enviadas para lotes exclusivos serão removidas.
                  <strong style="color: #3a3939">Esta ação não poderá ser desfeita.</strong>
                  Deseja continuar?
                </v-card-text>
                <v-card-actions class="acoes justify-space-between pb-2">
                  <v-btn class="mx-2" color="#777" style="border: 1px solid grey" flat @click="exibirModalConfirmarAlteracaoMeEpp = false">
                    Voltar
                  </v-btn>
                  <v-btn class="mx-2 primary confirmar" flat @click="confirmarAlteracaoMeEpp">
                    Confirmar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </az-form>
    </az-container>
</template>

<script>
    import CredenciamentoFornecedorTermosCredenciamento from './CredenciamentoFornecedorTermosCredenciamento.vue'
    import CredenciamentoFornecedorTermosHabilitacao from './CredenciamentoFornecedorTermosHabilitacao.vue'
    import CredenciamentoFornecedorTermosInfoEmpresa from './CredenciamentoFornecedorTermosInfoEmpresa.vue'
    import {actionTypes} from '@/commons/constants'
    import {mapState} from 'vuex'
    import CredenciamentoFornecedorTermosPersonalizados
      from "@/views/credenciamento/detalhe-credenciamento/fornecedor/termos/CredenciamentoFornecedorTermosPersonalizados.vue";
    import _ from "lodash";

    export default {
        name: 'LicitacaoFornecedorTermos',
        components: {
            CredenciamentoFornecedorTermosPersonalizados,
            CredenciamentoFornecedorTermosCredenciamento,
            CredenciamentoFornecedorTermosHabilitacao,
            CredenciamentoFornecedorTermosInfoEmpresa
        },
        data() {
            return {
                aceite: {
                    isMeEppMei: undefined,
                    termosAceitos: []
                },
                confirmouAlteracaoMeEpp: false,
                exibirModalConfirmarAlteracaoMeEpp: false,
                passos: {
                    informacoesEmpresa: {
                        sequencia: 1,
                        label: 'Informações da Empresa'
                    },
                    termoCredenciamento: {
                        sequencia: 2,
                        label: 'Termo de Credenciamento'
                    },
                    termoHabilitacao: {
                        sequencia: 3,
                        label: 'Termo de Habilitação'
                    },
                    termosPersonalizadosProposta: {
                        sequencia: 4,
                        label: 'Termos de Proposta'
                    },
                    termosPersonalizadosHabilitacao: {
                        sequencia: 5,
                        label: 'Termos de Habilitação'
                    }
                },
                passoAtual: undefined,
                licitacaoId: undefined,
                termos: []
            }
        },
        computed: {
            ...mapState(['licitacao', 'propostaResumo']),
            chaves() {
              const chaves = ['informacoesEmpresa', 'termoCredenciamento', 'termoHabilitacao']
              if(this.licitacao.amparoLegal.lei.includes('Lei 14.133/2021')){
                chaves.push('termosPersonalizadosProposta')
                chaves.push('termosPersonalizadosHabilitacao')
              }
              return chaves
            },
            ehPerfilSiga(){
              return !this.$store.state.parametros.propriedadesLicitacao.ehPerfilComprasBR
            },
            passosFiltrados(){
              const passos = _.cloneDeep(this.passos)
              if(!this.licitacao.amparoLegal.lei.includes('Lei 14.133/2021')) {
                delete passos["termosPersonalizadosProposta"];
                delete passos["termosPersonalizadosHabilitacao"];
              }
              return passos
            },
            termosProposta(){
              return this.termos.filter(termo => termo.tipo === 'PROPOSTA' || !termo.tipo)
            },
            termosHabilitacao(){
              return this.termos.filter(termo => termo.tipo === 'HABILITACAO')
            }
        },
        created() {
            this.passoAtual = this.passos.informacoesEmpresa
        },
        async mounted() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarTermos()
        },
        methods: {
            precisaConfirmarAlteracaoExclusividade(){
              const eraMicroEmpresa = this.propostaResumo.propostaTermo && this.propostaResumo.propostaTermo.microEmpresa === 'S'
              const alterouMicroEmpresa = this.aceite.isMeEppMei === 'N'
              return eraMicroEmpresa && alterouMicroEmpresa && !this.confirmouAlteracaoMeEpp
            },
            confirmarAlteracaoMeEpp(){
              this.confirmouAlteracaoMeEpp = true
              this.finalizar()
            },
            async finalizar() {
                if(this.precisaConfirmarAlteracaoExclusividade()){
                  this.exibirModalConfirmarAlteracaoMeEpp = true
                  return
                }
                await this.inserirTermoLicitacao()
                this.$emit('concluido')
                this.$emit('fechar')
                this.$router.replace({
                  name: 'licitacaoFornecedorProposta',
                  params: {
                    id: this.licitacao.id
                  }
                })
            },
            async buscarTermos(){
              this.termos = await this.$store.dispatch(actionTypes.BUSCAR_TERMOS, this.licitacao.id)
            },
            async inserirTermoLicitacao() {
                await this.$store.dispatch(actionTypes.INSERIR_TERMO_LICITACAO, {
                    licitacaoId: this.licitacaoId,
                    isMeEppMei: this.aceite.isMeEppMei,
                    termosAceitos: this.aceite.termosAceitos
                })
                this.mostrarNotificacaoSucessoDefault()
                await this.$store.dispatch(actionTypes.BUSCAR_PROPOSTA_RESUMO, this.licitacaoId)
            },
            isPassoCompleto(passo) {
                return this.passoAtual.sequencia > passo.sequencia
            },
            isPassoSelecionado(passo) {
                return this.passoAtual.sequencia === passo.sequencia
            },
            selecionarChavePasso(sequencia) {
                return this.chaves[sequencia - 1]
            },
            selecionarChavePassoAnterior() {
                return this.selecionarChavePasso(this.passoAtual.sequencia - 1)
            },
            selecionarChaveProximoPasso() {
                return this.selecionarChavePasso(this.passoAtual.sequencia + 1)
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            proximoPasso() {
                const chaveProximoPasso = this.selecionarChaveProximoPasso()
                if (!chaveProximoPasso) {
                    this.finalizar()
                } else {
                    this.passoAtual = this.passos[chaveProximoPasso]
                }
            },
            voltarPasso() {
                this.passoAtual = this.passos[this.selecionarChavePassoAnterior()]
            }
        }
    }
</script>

<style lang="stylus">

    .modal-boddy
        display: block
        .modal-text
            color: #777
            margin: 50px 50px 25px
            .text-center
                text-align: center
            .text-justify
                text-align: justify

    .modal-actions
        &__actions
            display: flex
            justify-content: space-between
            align-items: center
            margin: 0 250px 20px
            padding: 10px
        &__steps
            display: flex
            justify-content: space-between
            align-items: center
            border-top: 1px solid #ccc
            padding 10px
            font-size: 13px
            color: #777
            .v-btn__content
                font-size 13px
                text-transform none !important

    .v-stepper__header
        flex-wrap: nowrap !important
        height: 44px !important
        background-color: darken(#3a6861, 30%)

    .v-stepper__step
        padding 0 10px !important

    .v-stepper__step__step
        background: rgba(0, 0, 0, .25)
        font-size: 13px

    .v-stepper__label
        color: rgba(0, 0, 0, .8) !important
        font-size: 13px

    .v-stepper__step--active .v-stepper__label
        color: white !important

    .v-stepper .v-stepper__header .v-divider
        background: rgba(0, 0, 0, .5) !important

    .v-stepper__content
        padding: 0 !important

    .v-input--checkbox
        font-weight: bold

    .accent--text
        color: #3a6861 !important

    .acoes
      padding 20px 0 !important

</style>
